/**
 * 即梦 4.0（doubao-seedream-4-0-250828）manifest
 * 数据来源：image.json field_map
 * 特点：1K/2K/4K 三档清晰度，各档比例带真实像素（选清晰度联动换比例组）；参考图上限 6
 */
import type { ImageModelConfig } from '../../types';

export const jimeng4_0: ImageModelConfig = {
  id: '01K5THTJEFMSVQE36JJPKQ90V0',
  isDefault: true,
  displayName: '即梦 4.0',

  defaults: {
    ratio: '9:16', // 2K 档 select: true 项
    resolution: '2K', // 接口 resolution.default
  },

  ratioOptions: {
    '1K': [
      { label: '1:1', value: '1:1', width: 1024, height: 1024 },
      { label: '2:3', value: '2:3', width: 832, height: 1248 },
      { label: '3:2', value: '3:2', width: 1248, height: 832 },
      { label: '3:4', value: '3:4', width: 864, height: 1152 },
      { label: '4:3', value: '4:3', width: 1152, height: 864 },
      { label: '9:16', value: '9:16', width: 720, height: 1280 },
      { label: '16:9', value: '16:9', width: 1280, height: 720 },
      { label: '21:9', value: '21:9', width: 1512, height: 648 },
    ],
    '2K': [
      { label: '1:1', value: '1:1', width: 2048, height: 2048 },
      { label: '2:3', value: '2:3', width: 1664, height: 2496 },
      { label: '3:2', value: '3:2', width: 2496, height: 1664 },
      { label: '3:4', value: '3:4', width: 1728, height: 2304 },
      { label: '4:3', value: '4:3', width: 2304, height: 1728 },
      { label: '9:16', value: '9:16', width: 1440, height: 2560 },
      { label: '16:9', value: '16:9', width: 2560, height: 1440 },
      { label: '21:9', value: '21:9', width: 3024, height: 1296 },
    ],
    '4K': [
      { label: '1:1', value: '1:1', width: 4096, height: 4096 },
      { label: '2:3', value: '2:3', width: 3342, height: 5013 },
      { label: '3:2', value: '3:2', width: 5013, height: 3342 },
      { label: '3:4', value: '3:4', width: 3543, height: 4724 },
      { label: '4:3', value: '4:3', width: 4724, height: 3543 },
      { label: '9:16', value: '9:16', width: 3072, height: 5461 },
      { label: '16:9', value: '16:9', width: 5461, height: 3072 },
      { label: '21:9', value: '21:9', width: 6252, height: 2683 },
    ],
  },

  resolutionOptions: [
    { label: '标清 1K', value: '1K' },
    { label: '高清 2K', value: '2K' },
    { label: '超清 4K', value: '4K' },
  ],
  resolutionLabel: '图片质量', // 接口 field_map.resolution.label

  qualityOptions: [],

  toggles: {},

  limits: {
    maxRefImages: 6, // 接口 field_map.ref_images.max
    // 生成图尺寸校验（转写自 verification.ts 原即梦4.0 硬编码：宽×高 ∈ [930000, 16770000]）
    generationConstraints: {
      pixelCount: { min: 930000, max: 16770000 },
    },
  },
};
